import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
/* empty css                                                    */
import { createElementBlock, createVNode, openBlock, renderSlot, resolveComponent, unref, withCtx } from "vue";
import { DtToggle } from "@dialpad/dialtone-vue";
//#region src/components/controls/control_boolean.vue
var _hoisted_1 = { class: "dtc-control-boolean" };
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcControlBoolean" }, {
	props: {
		value: {
			type: Boolean,
			default: () => false
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	emits: [VALUE_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		return (_ctx, _cache) => {
			const _component_dt_text = resolveComponent("dt-text");
			return openBlock(), createElementBlock("div", _hoisted_1, [createVNode(unref(DtToggle), {
				"model-value": __props.value,
				disabled: __props.disabled,
				"label-class": "d-label--sm d-fc-secondary",
				size: 200,
				class: "d-jc-space-between",
				"data-qa": "dtc-control-boolean-input",
				onChange: _cache[0] || (_cache[0] = (e) => emit(unref("update:value"), e))
			}, {
				default: withCtx(() => [createVNode(_component_dt_text, {
					kind: "label",
					size: 100,
					tone: "secondary",
					class: "d-input__label-text d-mbe-0"
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
					_: 3
				})]),
				_: 3
			}, 8, ["model-value", "disabled"])]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=control_boolean.vue.js.map